import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { MatDialog } from '@angular/material';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { UtilityService } from '../../../../services/utilities/utilities.services';
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { ConfirmdialogComponent } from '../../../common/dialog/confirmdialog.component';
import { Router } from '@angular/router';
import { OrderPipe } from 'ngx-order-pipe';

@Component({
  selector: 'hybse-admin-list-market',
  templateUrl: './list-market.component.html',
  styleUrls: ['./list-market.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class ListMarketComponent implements OnInit {

  fadeInDown: any;
  marketList: any = [];
  showLoader: boolean = true;
  marketTitle: string = "Markets";
  errorMessage: string;
  @Input() isDemo: boolean = false;
  public limit: number = 50;
  public count: number;
  public offset: number = 0;
  public search: string;
  public filterType: number;
  public name: string;
  public ibin: string;
  public pairSource: string;

  //sorting
  order: string = 'initialValue';
  reverse: boolean = false;
  sortedCollection: any[];

  constructor(
    private _api: ApirequestService,
    private _utils: UtilityService,
    private dialog: MatDialog,
    private _urls: ApiurlsService,
    private _router: Router,
    private orderPipe: OrderPipe
  ) { }

  ngOnInit() {
    this.sortedCollection = this.orderPipe.transform(this.marketList, this.order);
    this.getMarketList();
  }
  getMarketList() {

    let data = {
      offset: this.offset,
      limit: this.limit,
    }
    if (this.search || this.filterType) {
      data['search'] = this.search;
      data['filterType'] = this.filterType;
    }

    let url = (this.isDemo) ? this._urls.demoMarketListUrl : this._urls.marketListUrl;
    this.marketList = [];
    this._api.fetchApiData(url, data, 'get').subscribe(
      (data: any) => {
        let resSucc = data.data;
        let resError = data.error;
        if (resSucc != '') {
          this.marketList = resSucc.marketList;
          this.count = resSucc.count;
        }
        if (resError != '') {
          this.errorMessage = resError['errorDescription'];
        }
      },
      error => {

      },
      () => {
        this.showLoader = false;
      }
    )
  }

  confirmDelete(id) {
    const deleteDialog = this.dialog.open(ConfirmdialogComponent, {
      width: '400px',
      height: '170px',
      data: {
        message: 'Are you sure to delete?'
      }
    });
    deleteDialog.afterClosed().subscribe(
      data => {
        if (data) this.deleteItem(id);
      }
    );
  }

  deleteItem(id) {
    let data = { idCompanyStock: id };
    this._api.fetchApiData(this._urls.deleteMarketUrl, data).subscribe(
      (data: any) => {
        let response = data.data;
        if (response != 0) this.deleteItemFromList(id);
      },
      error => {

      },
      () => {

      }
    );
  }

  deleteItemFromList(id) {
    this.marketList = this._utils.filterArrayObj(this.marketList, 'idCompanyStock', id);
  }

  getRouteNew() {
    (this.isDemo) ? this._router.navigate(['/demo-company/markets/create']) : this._router.navigate(['/markets/add'])
  }

  ngOnChanges() {
    this.marketTitle = (this.isDemo) ? 'Demo Markets' : 'Markets';
  }

  public doSomething(): void {
    if (!this.pairSource && !this.name && !this.ibin) {
      this.filterType = undefined;
      this.search = undefined;
      this.getMarketList();
    }
  }

  public selectedSearch(type: string) {
    if (type === 'ibin') {
      this.filterType = 5;
      this.search = this.ibin;
    } else if (type === 'companyName') {
      this.filterType = 6;
      this.search = this.name;
    } else {
      this.filterType = 7;
      this.search = this.pairSource;
    }
    this.getMarketList();
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    if (value === "createdAt") {
      this.reverse ? this.filterType = 1 : this.filterType = 2;
      this.getMarketList();
    } else {
      this.reverse ? this.filterType = 3 : this.filterType = 4;
      this.getMarketList();
    }
    this.order = value;
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/markets/list-market/list-market.component.ts